import PropTypes from "prop-types";
import { Carrousel } from "../../molecules/custom";
import { Banner } from "../../molecules/common";
import HeaderContent from "../../../constant/headerConte.json";
import OptionsInterest from "../../../constant/optionInterest.json";
import { Button, Input, TextArea } from "../../atoms/common";
import { Link } from "react-router-dom";
import { HeaderBackground } from "../../../assets/gift";
import { AiOutlineArrowRight, AiOutlineRight} from 'react-icons/ai';
import { useEffect, useState } from "react";
import converterTagHtml from "../../../helpers/converterTagHtml";
import SelectBar from "../../atoms/custom/selectBar";
import AOS from 'aos';

const DashboardPage = (props) => {
  const {dataNews, dataBusiness, dataHeader, sendFeedback} = props;
  const [dataWorkUs, setDataWorkUs] = useState({
    interest_with: '',
    name: '',
    email: '',
    company: '',
    description: '',
  })

  const onSubmit = (e) =>{
    e.preventDefault();
    sendFeedback(dataWorkUs);
  }

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <section className="h-screen container">
        <Carrousel
          duration={3000}
          navigate
          paginate
          btnNextClasses="flex absolute top-0 right-0 z-30 justify-center items-center px-4 h-full cursor-pointer group focus:outline-none"
          btnPrevClasses="flex absolute top-0 left-0 z-30 justify-center items-center px-4 h-full cursor-pointer group focus:outline-none"
        >
          {HeaderContent.map((item) => (
            <Banner
              imgUrl={HeaderBackground}
              classes={"bg-no-repeat bg-cover bg-center h-full w-full"}
            >
              <div className="h-full text-white flex items-center px-28 tablet:px-10">
                <div className="flex flex-col items-start">
                  <h1 className="font-bold text-4xl whitespace-pre">
                    {item.title}
                  </h1>
                  <div className="bg-slate-700/[0.5] p-4 mt-4 border-l-4">
                    <span className="font-medium text-base">
                      {item.description}
                    </span>
                  </div>
                  {item?.link?.length > 0 ? (
                    <>
                      {item?.link?.map((subItem, subIndex) => (
                        <Link key={subIndex} className="flex text-sm" to={item.link[subIndex]?.link}>
                          <span>{item.link[subIndex]?.text}</span>
                          <AiOutlineArrowRight />
                        </Link>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </Banner>
          ))}
        </Carrousel>
      </section>
      <section  className="w-full flex flex-col justify-center bg-white">
        <div className="flex">
          <div className="w-1/4 bg-gray-300">
              
          </div>
          <div className="w-[75%] flex flex-col justify-end px-10">
            <p className="text-greenWebsite mt-16 text-sm">SAGARA GROUP IS ONE OF THE WORLD’S LEADING MULTI HIGH-GROWTH ASSETS INVESTMENT FIRMS.
OUR GLOBAL TEAM ALIGNS OUR INTERESTS WITH THOSE OF OUR INVESTORS AND PARTNERS FOR LASTING IMPACT.</p>
            <span className="text-bold text-5xl font-bold">Our Businesses</span>
          </div>
        </div>
        <div className="flex flex-wrap items-stretch h-full p-10">
          {dataBusiness?.map((item, index) => (
            <div className="w-1/4 tablet:w-full h-full p-8 flex flex-col items-stretch" key={index}>
              <div className="flex w-full">
                <div className="w-[40%] h-16">
                  <img src={item?.image} alt='...' className="w-full h-full"/>
                </div>
                <div className="w-[60%]">
                  <span className="text-xl font-bold ml-3">{item?.title}</span>
                </div>
              </div>
              <div className="my-3">
                {converterTagHtml(item?.description)}
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* end */}
      <section className="w-full flex justify-center bg-white p-10">
        <div className="w-[35%] flex-col">
          <div className="text-greenWebsite mb-4">
            <span className="text-xs">SAGARA GROUP</span>
          </div>
          <div className="text-4xl font-bold mb-4">
            <p>
            Sagara Group is a leading multi high-growth assets investment firms on behalf of pension funds, large institutions and individuals.
            </p>
          </div>
          <Link className="flex items-center justify-between text-greenWebsite" to='/'>
            <span className="flex w-[30%] font-bold text-sm">
              LP LOGIN
            </span>
            <div className="w-[70%] flex justify-center overflow-x-hidden">
              {/* <AiOutlineRight className="w-full"/> */}
              <AiOutlineArrowRight className="w-full"/>
            </div>
          </Link>
        </div>
        <div className="w-[65%] flex flex-col pl-12">
          <p className="text-2xl mb-10 text-left ">
          Sagara Group aims to help growing business reach their full potential with technology touch. We focus on companies in large, growing end markets with innovative or disruptive technology where we believe we can support transformational growth.
          </p>
          <div className="flex w-full text-lg">
            <p className="w-1/2 pr-8">Sagara Group team combines deep technology expertise and strong relationships with rigorous investment approach and ability to support management teams in their efforts to professionalize and scale.</p>
            <p className="w-1/2 pr-8">Sagara Group team is an experienced senior team that brings backgrounds in private and public equity investing as well as technology operating roles.</p>
          </div>
        </div>
      </section>
      <section className="w-full flex flex-col justify-center bg-white p-10">
        <span className="text-4xl font-semibold">Latest news & insights</span>
        <div data-aos="fade" className="grid grid-cols-3 gap-4 ">
          {dataNews?.map((item, index) => (
            <div key={index} className="first:col-span-2 col-span-1 h-[250px] bg-dark">
              <Banner
                imgUrl={item?.post_image}
                classes={'bg-no-repeat bg-cover bg-center h-full w-full'}
              >
                <div className="flex items-end w-full h-full text-white">
                  <div className="flex flex-col bg-dark/50 w-full p-2">
                    <span>{item?.post_title}</span>
                    <p>{converterTagHtml(item?.post_content)}</p>
                  </div>
                </div>
              </Banner>
            </div>
          ))}
        </div>
      </section>
      <section className="w-full flex tablet:flex-col justify-center items-stretch p-10">
        <div className="w-1/2 tablet:w-full p-6 flex items-center">
          <div className="flex flex-col"> 
            <div className="mb-2">
              <span className="text-greenWebsite">OUR FACTS IN NUMBER</span>
            </div>
            <div className="mb-2">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in.</span>
              <Link to={'/'} className="ml-1 text-greenWebsite">
                Read More
              </Link>
            </div>
            <div className="flex flex-wrap">
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">10</span>
                  <span className="text-xl font-thin ml-1">Portfolio Companies</span>
                </div>
                <span className="mt-2 text-base ml-1">
                  We've been operating since 2014
                </span>
              </div>
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">3X</span>
                  <span className="text-xl font-thin ml-1">Value Multiples</span>
                </div>
                <span className="mt-2 text-base ml-1">
                We've helped 990+ clients achieve their goals
                </span>
              </div>
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">6</span>
                  <span className="text-xl font-thin ml-1">Offices</span>
                </div>
                <span className="mt-2 text-base ml-1">
                Our locations are spreaded accross 5 continents
                </span>
              </div>
              <div className="w-1/2 p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">20+</span>
                  <span className="text-xl font-thin ml-1">Professionals</span>
                </div>
                <span className="mt-2 text-base ml-1">
                We've awarded as the best business consulting in 2020
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2 tablet:w-full p-6">
          <form className="bg-white flex flex-col shadow-md p-6 w-full" onSubmit={onSubmit}>
            <span className="text-4xl font-bold">Work With Us</span>
            <span className="text-md my-2 w-full">We will respond to your email within 24 hours</span>
            <SelectBar
              data={OptionsInterest}
              value={dataWorkUs.interest_with}
              handler={(e) => setDataWorkUs({...dataWorkUs, interest_with: e.target.value})}
              defaultChoose={'Pilih Interest...'}
            />
            <Input
              placeHolder="Name"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              type="text"
              required
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.name}
              handler={(e) => setDataWorkUs({...dataWorkUs, name: e})}
            />
            <Input
              placeHolder="Email"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.email}
              type="email"
              required
              handler={(e) => setDataWorkUs({...dataWorkUs, email: e})}
            />
            <Input
              placeHolder="Company"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.company}
              type="text"
              required
              handler={(e) => setDataWorkUs({...dataWorkUs, company: e})}
            />
            <TextArea
              classes={'w-full h-[200px] rounded-m p-1 border-gray-500 border-b'}
              required
              placeHolder={'Project Description'}
              value={dataWorkUs.description}
              handler={(e) => setDataWorkUs({...dataWorkUs, description: e})}
            />
            <Button
              type={'submit'}
              text={'TALK TO OUR TEAM'}
              classes="text-white font-base bg-greenWebsite p-2 rounded-full my-2 w-1/3 tablet:w-1/2"
            />
          </form>
        </div>
      </section>
    </div>
  );
};

DashboardPage.propTypes = {
  linkBanner: PropTypes.string,
};

export default DashboardPage;
